/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { AddressName } from '../models/AddressName';
import type { AssignmentId } from '../models/AssignmentId';
import type { CameraChannelId } from '../models/CameraChannelId';
import type { CameraChannelName } from '../models/CameraChannelName';
import type { CameraChannelNumber } from '../models/CameraChannelNumber';
import type { CameraChannelsAll } from '../models/CameraChannelsAll';
import type { CameraQueueCommon } from '../models/CameraQueueCommon';
import type { CameraQueueStatus } from '../models/CameraQueueStatus';
import type { CameraQueueUpdatedAt } from '../models/CameraQueueUpdatedAt';
import type { CameraRecorderSince } from '../models/CameraRecorderSince';
import type { CameraRecorderSinceUntil } from '../models/CameraRecorderSinceUntil';
import type { CameraRecorderUntil } from '../models/CameraRecorderUntil';
import type { DateOnly } from '../models/DateOnly';
import type { DtcoActivity } from '../models/DtcoActivity';
import type { GroupsArray } from '../models/GroupsArray';
import type { IntervalId } from '../models/IntervalId';
import type { IntervalName } from '../models/IntervalName';
import type { ObuSince } from '../models/ObuSince';
import type { ObuSinceUntil } from '../models/ObuSinceUntil';
import type { ObuUntil } from '../models/ObuUntil';
import type { SetOdometer } from '../models/SetOdometer';
import type { Triggers } from '../models/Triggers';
import type { TriggersNullable } from '../models/TriggersNullable';
import type { UserAssignmentId } from '../models/UserAssignmentId';
import type { UserId } from '../models/UserId';
import type { UserIdentity } from '../models/UserIdentity';
import type { VehicleAttr } from '../models/VehicleAttr';
import type { VehicleCommand } from '../models/VehicleCommand';
import type { VehicleCommandType } from '../models/VehicleCommandType';
import type { VehicleIcon } from '../models/VehicleIcon';
import type { VehicleId } from '../models/VehicleId';
import type { VehicleInfo } from '../models/VehicleInfo';
import type { VehicleScheduleBase } from '../models/VehicleScheduleBase';
import type { VehicleScheduleCameraDownload } from '../models/VehicleScheduleCameraDownload';
import type { VehicleScheduleId } from '../models/VehicleScheduleId';
import type { VehicleSchedulePrivate } from '../models/VehicleSchedulePrivate';
import type { VehicleSetupSet } from '../models/VehicleSetupSet';
import type { VehicleType } from '../models/VehicleType';
import type { VIN } from '../models/VIN';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class VehicleService {
    constructor(public readonly http: HttpClient) {}
    /**
     * List all
     * List all available vehicles
     * @returns any OK
     * @throws ApiError
     */
    public vehicleListAll(): Observable<Array<({
        groups?: GroupsArray;
        identities?: Array<(UserIdentity & {
            activity: DtcoActivity;
            is_driver: boolean;
            operator_id: string | null;
        })> | null;
    } & VehicleInfo & {
        groups: GroupsArray;
        identities: Array<(UserIdentity & {
            activity: DtcoActivity;
            is_driver: boolean;
            operator_id: string | null;
        })> | null;
    })>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/vehicles/',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                500: `Server error`,
            },
        });
    }
    /**
     * Create
     * Create vehicle
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public vehicleCreate(
        requestBody: ({
            groups?: GroupsArray;
        } & {
            vin?: VIN;
        } & VehicleType & {
            groups: GroupsArray;
            vin: VIN;
            attr: VehicleAttr;
            icon: VehicleIcon;
        }),
    ): Observable<{
        id: VehicleId;
    }> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/vehicles/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                409: `Conflict`,
                500: `Server error`,
            },
        });
    }
    /**
     * Set trigger
     * Set trigger
     * @param vehicleId Vehicle ID
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public triggerSet(
        vehicleId: string,
        requestBody: Triggers,
    ): Observable<any> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/vehicles/{vehicle_id}/triggers',
            path: {
                'vehicle_id': vehicleId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                500: `Server error`,
            },
        });
    }
    /**
     * Setup
     * Set vehicle setup
     *
     * `consumption_norm`, `idle_tolerance`, `fuel_loss_tolerance`, `refueling_tolerance`, `trip_duration`, `speed_limit`, `cornering_tolerance`, `braking_tolerance` and `acceleration_tolerance` require less permissions in order to set
     * @param vehicleId Vehicle ID
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public vehicleSetup(
        vehicleId: string,
        requestBody: VehicleSetupSet,
    ): Observable<any> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/vehicles/{vehicle_id}/setup',
            path: {
                'vehicle_id': vehicleId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                500: `Server error`,
            },
        });
    }
    /**
     * Edit service interval
     * Edit vehicle service interval. An omitted limit is removed, unless both are omitted.
     * @param vehicleId Vehicle ID
     * @param intervalId Interval ID
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public vehicleServiceIntervalEdit(
        vehicleId: string,
        intervalId: string,
        requestBody: (IntervalName | SetOdometer | DateOnly),
    ): Observable<void> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/vehicles/{vehicle_id}/service_interval/{interval_id}',
            path: {
                'vehicle_id': vehicleId,
                'interval_id': intervalId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                412: `Precondition error`,
                500: `Server error`,
            },
        });
    }
    /**
     * Delete service interval
     * Delete vehicle service interval
     * @param vehicleId Vehicle ID
     * @param intervalId Interval ID
     * @returns void
     * @throws ApiError
     */
    public vehicleServiceIntervalDelete(
        vehicleId: string,
        intervalId: string,
    ): Observable<void> {
        return __request(OpenAPI, this.http, {
            method: 'DELETE',
            url: '/vehicles/{vehicle_id}/service_interval/{interval_id}',
            path: {
                'vehicle_id': vehicleId,
                'interval_id': intervalId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                500: `Server error`,
            },
        });
    }
    /**
     * List service intervals
     * List vehicle service intervals
     * @param vehicleId Vehicle ID
     * @returns any OK
     * @throws ApiError
     */
    public vehicleServiceIntervalList(
        vehicleId: string,
    ): Observable<Array<(IntervalId & IntervalName & {
        /**
         * If the interval was already activated
         */
        activated?: boolean;
        /**
         * When will it active
         */
        date?: string | null;
        /**
         * In what odometer will it active (m)
         */
        odometer?: number | null;
    } & {
        /**
         * If the interval was already activated
         */
        activated: boolean;
        /**
         * When will it active
         */
        date: string | null;
        /**
         * In what odometer will it active (m)
         */
        odometer: number | null;
    })>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/vehicles/{vehicle_id}/service_interval/',
            path: {
                'vehicle_id': vehicleId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                500: `Server error`,
            },
        });
    }
    /**
     * Set service interval
     * Set vehicle service interval. With both limits it fires on whichever comes first.
     * @param vehicleId Vehicle ID
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public vehicleServiceInterval(
        vehicleId: string,
        requestBody: (IntervalName & (SetOdometer | DateOnly)),
    ): Observable<{
        /**
         * Interval ID
         */
        id: string;
    }> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/vehicles/{vehicle_id}/service_interval/',
            path: {
                'vehicle_id': vehicleId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                412: `Precondition error`,
                500: `Server error`,
            },
        });
    }
    /**
     * Edit schedule
     * Update a vehicle schedule
     * @param vehicleId Vehicle ID
     * @param scheduleId Schedule ID
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public vehicleScheduleEdit(
        vehicleId: string,
        scheduleId: string,
        requestBody: VehicleScheduleBase,
    ): Observable<void> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/vehicles/{vehicle_id}/schedules/{schedule_id}/',
            path: {
                'vehicle_id': vehicleId,
                'schedule_id': scheduleId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                409: `Conflict`,
                412: `Precondition error`,
                500: `Server error`,
            },
        });
    }
    /**
     * Delete schedule
     * Delete a vehicle schedule
     * @param vehicleId Vehicle ID
     * @param scheduleId Schedule ID
     * @returns void
     * @throws ApiError
     */
    public vehicleScheduleDelete(
        vehicleId: string,
        scheduleId: string,
    ): Observable<void> {
        return __request(OpenAPI, this.http, {
            method: 'DELETE',
            url: '/vehicles/{vehicle_id}/schedules/{schedule_id}/',
            path: {
                'vehicle_id': vehicleId,
                'schedule_id': scheduleId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                500: `Server error`,
            },
        });
    }
    /**
     * List schedules
     * List vehicle schedules
     * @param vehicleId Vehicle ID
     * @param type Filter by schedule type
     * @returns any OK
     * @throws ApiError
     */
    public vehicleScheduleList(
        vehicleId: string,
        type?: 'private' | 'camera-download',
    ): Observable<Array<((VehicleSchedulePrivate & {
        id: VehicleScheduleId;
    }) | (VehicleScheduleCameraDownload & {
        id: VehicleScheduleId;
    }))>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/vehicles/{vehicle_id}/schedules/',
            path: {
                'vehicle_id': vehicleId,
            },
            query: {
                'type': type,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                500: `Server error`,
            },
        });
    }
    /**
     * Create schedule
     * Create a vehicle schedule
     * @param vehicleId Vehicle ID
     * @param requestBody
     * @returns any Schedule created
     * @throws ApiError
     */
    public vehicleScheduleCreate(
        vehicleId: string,
        requestBody: ((VehicleSchedulePrivate & Record<string, any>) | (VehicleScheduleCameraDownload & Record<string, any>)),
    ): Observable<{
        id: VehicleScheduleId;
    }> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/vehicles/{vehicle_id}/schedules/',
            path: {
                'vehicle_id': vehicleId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                409: `Conflict`,
                412: `Precondition error`,
                500: `Server error`,
            },
        });
    }
    /**
     * Set vehicle odometer
     * Set vehicle odometer
     * @param vehicleId Vehicle ID
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public vehicleOdometer(
        vehicleId: string,
        requestBody: (SetOdometer & {
            /**
             * Date
             */
            date?: string;
        } & {
            /**
             * Date
             */
            date: string;
        }),
    ): Observable<any> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/vehicles/{vehicle_id}/odometer',
            path: {
                'vehicle_id': vehicleId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                409: `Conflict`,
                412: `Precondition error`,
                500: `Server error`,
            },
        });
    }
    /**
     * Upload vehicle image
     * Upload vehicle image
     * @param vehicleId Vehicle ID
     * @param formData
     * @returns any OK
     * @throws ApiError
     */
    public vehicleImageUpload(
        vehicleId: string,
        formData: {
            /**
             * JPG image max size 5MB
             */
            file: Blob;
        },
    ): Observable<{
        /**
         * Image URL
         */
        url: string;
    }> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/vehicles/{vehicle_id}/image',
            path: {
                'vehicle_id': vehicleId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                500: `Server error`,
            },
        });
    }
    /**
     * Delete vehicle image
     * Delete vehicle image
     * @param vehicleId Vehicle ID
     * @returns any Image deleted
     * @throws ApiError
     */
    public vehicleImageDelete(
        vehicleId: string,
    ): Observable<any> {
        return __request(OpenAPI, this.http, {
            method: 'DELETE',
            url: '/vehicles/{vehicle_id}/image',
            path: {
                'vehicle_id': vehicleId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                500: `Server error`,
            },
        });
    }
    /**
     * OBU message thread
     * Message thread for the vehicle (outbound/inbound)
     * @param vehicleId Vehicle ID
     * @returns VehicleCommand Messages
     * @throws ApiError
     */
    public vehicleCommandList(
        vehicleId: string,
    ): Observable<Array<VehicleCommand>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/vehicles/{vehicle_id}/commands',
            path: {
                'vehicle_id': vehicleId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                500: `Server error`,
            },
        });
    }
    /**
     * Send OBU command
     * Send a command to the vehicle
     * @param vehicleId Vehicle ID
     * @param requestBody
     * @returns any Queued
     * @throws ApiError
     */
    public vehicleCommand(
        vehicleId: string,
        requestBody: {
            command: VehicleCommandType;
        },
    ): Observable<{
        status: 'queued';
    }> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/vehicles/{vehicle_id}/commands',
            path: {
                'vehicle_id': vehicleId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                412: `Precondition error`,
                500: `Server error`,
                503: `Could not send command`,
            },
        });
    }
    /**
     * Get camera queue
     * Get camera queue
     * @param vehicleId Vehicle ID
     * @param startDate Optional lower bound — only recordings starting at or after this time
     * @param endDate Optional upper bound — only recordings ending at or before this time
     * @returns any Download history
     * @throws ApiError
     */
    public cameraQueue(
        vehicleId: string,
        startDate?: string | null,
        endDate?: string | null,
    ): Observable<Array<(CameraQueueCommon & {
        channel: CameraChannelsAll;
        /**
         * Download URL (only if status is 5)
         */
        download_url?: string | null;
        /**
         * Camera queue ID
         */
        id: string;
        /**
         * Download/render progress percent (0-100), only meaningful while status is 3 or 4
         */
        progress?: number | null;
        status: CameraQueueStatus;
        updated_at: CameraQueueUpdatedAt;
    })>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/vehicles/{vehicle_id}/camera/queue',
            path: {
                'vehicle_id': vehicleId,
            },
            query: {
                'start_date': startDate,
                'end_date': endDate,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                500: `Server error`,
            },
        });
    }
    /**
     * Request camera recording
     * Request camera recording
     * @param vehicleId Vehicle ID
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public cameraRequest(
        vehicleId: string,
        requestBody: (CameraQueueCommon & {
            channel: CameraChannelsAll;
            /**
             * User ID to attribute the recording request to. If omitted, defaults to the authenticated user.
             */
            user_id?: string | null;
        }),
    ): Observable<void> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/vehicles/{vehicle_id}/camera/queue',
            path: {
                'vehicle_id': vehicleId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                409: `Conflict`,
                412: `Precondition error`,
                500: `Server error`,
            },
        });
    }
    /**
     * Camera live
     * Get live video stream
     * @param vehicleId Vehicle ID
     * @param channel Channel
     * @param type Type
     * @param substream Substream
     * @returns any Queue
     * @throws ApiError
     */
    public cameraLive(
        vehicleId: string,
        channel: number,
        type: 'rtsp' | 'hls' | 'web' | 'web_hls' = 'hls',
        substream: boolean = true,
    ): Observable<{
        /**
         * URL
         */
        url: string;
    }> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/vehicles/{vehicle_id}/camera/live',
            path: {
                'vehicle_id': vehicleId,
            },
            query: {
                'type': type,
                'substream': substream,
                'channel': channel,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                412: `Precondition error`,
                500: `Server error`,
            },
        });
    }
    /**
     * Edit camera channel
     * Edit camera channel
     * @param vehicleId Vehicle ID
     * @param channelId Channel ID
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public cameraChannelEdit(
        vehicleId: string,
        channelId: string,
        requestBody: {
            name?: string | null;
        },
    ): Observable<void> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/vehicles/{vehicle_id}/camera/channel/{channel_id}',
            path: {
                'vehicle_id': vehicleId,
                'channel_id': channelId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                500: `Server error`,
            },
        });
    }
    /**
     * Camera channels
     * List camera channels
     * @param vehicleId Vehicle ID
     * @returns any Channels
     * @throws ApiError
     */
    public cameraChannel(
        vehicleId: string,
    ): Observable<Array<{
        channel: CameraChannelNumber;
        id: CameraChannelId;
        name: CameraChannelName;
    }>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/vehicles/{vehicle_id}/camera/channel/',
            path: {
                'vehicle_id': vehicleId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                500: `Server error`,
            },
        });
    }
    /**
     * Camera status
     * Get camera status and connectivity
     * @param vehicleId Vehicle ID
     * @returns any Camera status and connectivity
     * @throws ApiError
     */
    public cameraStatus(
        vehicleId: string,
    ): Observable<{
        /**
         * Per-channel video-lost flag. Index 0 = channel 1.
         */
        channelVideoLost: Array<boolean>;
        gnssAntennaMissedOrCut: boolean;
        gnssAntennaShort: boolean;
        gnssModuleFault: boolean;
        hardDiskPowerOutage: boolean;
        hardDiskPresent: boolean;
        ignition: boolean;
        latitude: number;
        longitude: number;
        /**
         * Active network interface
         */
        network: 'mobile' | 'wifi' | 'wired' | null;
        /**
         * Whether the recorder is currently connected
         */
        online: boolean;
        /**
         * Signal strength, 0-5 (0 module absent … 5 extremely strong).
         */
        signalStrength: number;
    }> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/vehicles/{vehicle_id}/camera/',
            path: {
                'vehicle_id': vehicleId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                412: `Precondition error`,
                500: `Server error`,
            },
        });
    }
    /**
     * Edit operator vehicle assignment
     * Edit operator vehicle assignment
     * @param vehicleId Vehicle ID
     * @param assignmentId Identity assignment ID
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public vehicleAssignOperatorEdit(
        vehicleId: string,
        assignmentId: string,
        requestBody: ({
            /**
             * Since when is the identity assigned
             */
            since: string;
        } | {
            /**
             * Until when is the identity assigned
             */
            until: string | null;
        }),
    ): Observable<any> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/vehicles/{vehicle_id}/assign_operator/assignment/{assignment_id}',
            path: {
                'vehicle_id': vehicleId,
                'assignment_id': assignmentId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                409: `Conflict`,
                412: `Precondition error`,
                500: `Server error`,
            },
        });
    }
    /**
     * Delete operator vehicle assignment
     * Delete operator vehicle assignment
     * @param vehicleId Vehicle ID
     * @param assignmentId Identity assignment ID
     * @returns any Deleted
     * @throws ApiError
     */
    public vehicleAssignOperatorDelete(
        vehicleId: string,
        assignmentId: string,
    ): Observable<any> {
        return __request(OpenAPI, this.http, {
            method: 'DELETE',
            url: '/vehicles/{vehicle_id}/assign_operator/assignment/{assignment_id}',
            path: {
                'vehicle_id': vehicleId,
                'assignment_id': assignmentId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                500: `Server error`,
            },
        });
    }
    /**
     * Assign operator
     * Assign operator to vehicle, used instead of RFID/NFC/iButton login
     * @param vehicleId Vehicle ID
     * @param operatorId Operator ID
     * @param requestBody
     * @returns UserAssignmentId OK
     * @throws ApiError
     */
    public vehicleAssignOperator(
        vehicleId: string,
        operatorId: string,
        requestBody: {
            /**
             * Since when the operator is assigned to vehicle
             */
            since: string;
            /**
             * Until when will be the operator assigned to vehicle
             */
            until: string | null;
        },
    ): Observable<UserAssignmentId> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/vehicles/{vehicle_id}/assign_operator/{operator_id}/',
            path: {
                'vehicle_id': vehicleId,
                'operator_id': operatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                409: `Conflict`,
                412: `Precondition error`,
                500: `Server error`,
            },
        });
    }
    /**
     * Get assigned operators
     * Get assigned operators, used instead of RFID/NFC/iButton login
     * @param vehicleId Vehicle ID
     * @returns any OK
     * @throws ApiError
     */
    public vehicleAssignOperatorList(
        vehicleId: string,
    ): Observable<Array<{
        id: AssignmentId;
        operator_id: UserId;
        /**
         * Since when the operator is assigned to vehicle
         */
        since: string;
        /**
         * Until when will be the operator assigned to vehicle
         */
        until: string | null;
    }>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/vehicles/{vehicle_id}/assign_operator/',
            path: {
                'vehicle_id': vehicleId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                500: `Server error`,
            },
        });
    }
    /**
     * Detail
     * Get vehicle details
     * @param vehicleId Vehicle ID
     * @returns any OK
     * @throws ApiError
     */
    public vehicleDetail(
        vehicleId: string,
    ): Observable<(VehicleInfo & TriggersNullable & {
        groups?: GroupsArray;
        identities?: Array<(UserIdentity & {
            activity: DtcoActivity;
            is_driver: boolean;
            operator_id: string | null;
        })> | null;
        /**
         * Vehicle image url
         */
        image?: string | null;
        location?: AddressName | null;
    } & {
        triggers: {
            country?: boolean;
            cruise_control?: boolean;
            engine?: boolean;
            ext_in_1?: boolean;
            ext_in_2?: boolean;
            ext_in_3?: boolean;
            ext_in_4?: boolean;
            ext_in_5?: boolean;
            fms_pto?: boolean;
            fuel_loss?: boolean;
            fuel_loss_can?: boolean;
            geofence?: boolean;
            humidity?: boolean;
            ignition?: boolean;
            in_1?: boolean;
            in_2?: boolean;
            in_3?: boolean;
            in_4?: boolean;
            in_5?: boolean;
            overspeeding?: boolean;
            panic_alarm?: boolean;
            refueling?: boolean;
            refueling_can?: boolean;
            temperature?: boolean;
            thermo?: boolean;
            vehicle_activity?: boolean;
        } | null;
        groups: GroupsArray;
        identities: Array<(UserIdentity & {
            activity: DtcoActivity;
            is_driver: boolean;
            operator_id: string | null;
        })> | null;
        /**
         * Vehicle image url
         */
        image: string | null;
        location: AddressName | null;
    })> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/vehicles/{vehicle_id}/',
            path: {
                'vehicle_id': vehicleId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                500: `Server error`,
            },
        });
    }
    /**
     * Edit
     * Edit vehicle
     *
     * `icon` requires less permissions in order to set
     * @param vehicleId Vehicle ID
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public vehicleEdit(
        vehicleId: string,
        requestBody?: VehicleType,
    ): Observable<any> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/vehicles/{vehicle_id}/',
            path: {
                'vehicle_id': vehicleId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                412: `Precondition error`,
                500: `Server error`,
            },
        });
    }
    /**
     * Delete
     * Delete vehicle
     * @param vehicleId Vehicle ID
     * @param permanent
     * @returns any Vehicle deleted
     * @throws ApiError
     */
    public vehicleDelete(
        vehicleId: string,
        permanent: boolean = false,
    ): Observable<any> {
        return __request(OpenAPI, this.http, {
            method: 'DELETE',
            url: '/vehicles/{vehicle_id}/',
            path: {
                'vehicle_id': vehicleId,
            },
            query: {
                'permanent': permanent,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                500: `Server error`,
            },
        });
    }
    /**
     * Assign OBU to the vehicle
     * Assign OBU to the vehicle
     * @param code OBU serial number
     * @param vehicleId Vehicle ID
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public obuAssign(
        code: string,
        vehicleId: string,
        requestBody: ObuSinceUntil,
    ): Observable<void> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/obu/{code}/assign_vehicle/{vehicle_id}',
            path: {
                'code': code,
                'vehicle_id': vehicleId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                409: `Conflict`,
                500: `Server error`,
            },
        });
    }
    /**
     * Get latest OBU assignment
     * Get latest OBU assignment
     * @param code OBU serial number
     * @returns any Assignments
     * @throws ApiError
     */
    public obuAssignGet(
        code: string,
    ): Observable<({
        created_at?: string;
        id?: AssignmentId;
        vehicle_id?: VehicleId;
    } & ObuSince & ObuUntil & {
        id: AssignmentId;
        vehicle_id: VehicleId;
    })> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/obu/{code}/assign_vehicle/',
            path: {
                'code': code,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                412: `Precondition error`,
                500: `Server error`,
            },
        });
    }
    /**
     * Update camera queue status
     * Update camera queue status
     * @param sn Camera recorder serial number
     * @param queueId Queue ID
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public cameraQueueUpdate(
        sn: string,
        queueId: string,
        requestBody: {
            download_url?: string | null;
            /**
             * Download/render progress percent (0-100)
             */
            progress?: number | null;
            status: CameraQueueStatus;
        },
    ): Observable<void> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/cameras/{sn}/queue/{queue_id}',
            path: {
                'sn': sn,
                'queue_id': queueId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                500: `Server error`,
            },
        });
    }
    /**
     * Delete camera queue
     * Delete camera queue
     * @param sn Camera recorder serial number
     * @param queueId Queue ID
     * @returns void
     * @throws ApiError
     */
    public cameraQueueDelete(
        sn: string,
        queueId: string,
    ): Observable<void> {
        return __request(OpenAPI, this.http, {
            method: 'DELETE',
            url: '/cameras/{sn}/queue/{queue_id}',
            path: {
                'sn': sn,
                'queue_id': queueId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                500: `Server error`,
            },
        });
    }
    /**
     * Assign camera recorder to the vehicle
     * Assign camera recorder to the vehicle
     * @param sn Camera recorder serial number
     * @param vehicleId Vehicle ID
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public cameraAssignVehicle(
        sn: string,
        vehicleId: string,
        requestBody: CameraRecorderSinceUntil,
    ): Observable<void> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/cameras/{sn}/assign_vehicle/{vehicle_id}',
            path: {
                'sn': sn,
                'vehicle_id': vehicleId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                409: `Conflict`,
                500: `Server error`,
            },
        });
    }
    /**
     * Camera vehicle assignment
     * Camera recorder vehicle assignment
     * @param sn Camera recorder serial number
     * @returns any Assignments
     * @throws ApiError
     */
    public cameraAssignGet(
        sn: string,
    ): Observable<Array<({
        id: AssignmentId;
        vehicle_id: VehicleId;
    } & CameraRecorderSince & CameraRecorderUntil)>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/cameras/{sn}/assign_vehicle/',
            path: {
                'sn': sn,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                500: `Server error`,
            },
        });
    }
}
